import { FC, useEffect, useMemo } from 'react';
import { Button, ButtonStyles } from '@silverfort/sf-components';
import ReportsMenu from './ReportsMenu';
import RecurringRiskReport from './Reports/RecurringRiskReport';
import RiskReport from './Reports/RiskReport';
import CyberInsurance from './Reports/CyberInsurance';
import { REPORT_OPTIONS } from './consts';
import { ReportMenuOption } from './types';
import { useAppDrawer } from '../AppDrawer/AppDrawerProvider';
import { ReportsDrawerContextProvider, useReportsDrawer } from './ReportsDrawerContext';

const ReportsDrawer: FC = () => {
    return (
        <ReportsDrawerContextProvider>
            <ReportsDrawerContent />
        </ReportsDrawerContextProvider>
    );
};

const ReportsDrawerContent: FC = () => {
    const { selectedReportOption } = useReportsDrawer();
    const { updateAppDrawerProps, closeAppDrawer } = useAppDrawer();

    useEffect(() => {
        updateAppDrawerProps({
            headerTitle: 'Generate Customized Reports',
            headerInfo: 'Download a one-time report or schedule recurring reports',
            headerClassName: 'border-b border-[#EDEDED]',
            onClose: closeAppDrawer
        });
    }, []);

    const report = useMemo(() => {
        if (selectedReportOption === ReportMenuOption.SingleRiskReport) {
            return <RiskReport />;
        }
        if (selectedReportOption === ReportMenuOption.RecurringRiskReports) {
            return <RecurringRiskReport />;
        }
        if (selectedReportOption === ReportMenuOption.SingleCyberInsurance) {
            return <CyberInsurance />;
        }
    }, [selectedReportOption]);
    return (
        <div className="flex flex-col justify-between font-sf h-full w-136">
            <div className="flex flex-col h-full">
                <div className="flex flex-row gap-4 h-full">
                    <ReportsMenu options={REPORT_OPTIONS} />
                    {report}
                </div>
            </div>
            <div className="flex flex-row items-center justify-end h-14 gap-2 p-6 border-t border-sf-gray-100">
                <Button text="Cancel" buttonStyle={ButtonStyles.GhostSolid} onClick={closeAppDrawer} />
                <Button text="Close" onClick={closeAppDrawer} />
            </div>
        </div>
    );
};

export default ReportsDrawer;
